module.exports = __webpack_public_path__ + "img/download.e01be334.svg";